import { useCallback, useState } from 'react';
import { MealsComponent } from '../../../../components/molecules/MealsComponent/MealsComponent';
import type { UseChatHistoryHook, UseChatHistoryHookLoadings } from '../../../types/Chat.type';
import { MessageSenderEnum, type MessageOption, type MessageWithOptions } from '../../../types/Message.type';
import { fetchRest } from '../rest.client';

export const useChatHistory = (): UseChatHistoryHook => {
    const [error, setError] = useState<any>(null);
    const [chatState, setChatState] = useState<UseChatHistoryHookLoadings>({
        conversation: {
            error: null,
            loading: false,
            success: null,
            data: {
                messages: []
            }
        },
    });

    const getChat = useCallback(async (date: string) => {
        setChatState(prev => ({
            ...prev,
            conversation: {
                error: null,
                loading: true,
                success: null,
                data: {
                    messages: []
                }
            }
        }));
        setError(null);


        try {
            const result = await fetchRest({
                url: process.env.REACT_APP_MEAL_RECOMMENDER_URL + '/api/v1/chat/' + date,
            });

            if (result.error) {
                setChatState(prev => ({
                    ...prev,
                    conversation: {
                        ...prev?.conversation,
                        error: true,
                    }
                }));
            } else {
                setChatState(prev => ({
                    ...prev,
                    conversation: {
                        ...prev?.conversation,
                        success: true,
                        data: {
                            messages: (result?.messages as MessageOption[]).map(msg => {
                                const type = msg.sender;
                                const message = (msg?.message as MessageWithOptions);
                                const content = message?.answer || (msg?.message as string);

                                if (msg.sender === MessageSenderEnum.ai && 'meals' in message) {
                                    const meals = message.meals;

                                    return {
                                        content,
                                        type,
                                        options: [],
                                        interaction: 'meal-recommender',
                                        component:
                                            meals.length > 0 ?
                                                <MealsComponent data={meals} /> : undefined,
                                    }
                                }
                                return {
                                    content,
                                    type,
                                    options: [],
                                };
                            }) || [],
                        }
                    }
                }));
            }
        } catch (err) {
            setError(err);
        } finally {
            setChatState(prev => ({
                ...prev,
                conversation: {
                    ...prev?.conversation,
                    loading: false,
                }
            }));
        }
    }, []);


    return {
        error,
        chatState,
        getChat,
    };
};